import { genericAuthRequestErrorMessage } from "./axiosInstance.helper";

type ApiErrorBody = {
  code?: string;
  message?: string;
  data?: unknown;
};

const looksLikeSecretOrToken = (value: string): boolean =>
  /access[_-]?token|refresh[_-]?token|id[_-]?token|bearer\s+[a-z0-9._-]+/i.test(
    value,
  );

/**
 * Map API register/login failure body to a safe UI message.
 * Prefers Zod field messages from `data`; never surfaces token-shaped text.
 */
export const mapSafeRegisterError = (
  body: ApiErrorBody | null | undefined,
): { code: string; message: string } => {
  const code =
    typeof body?.code === "string" && body.code.trim()
      ? body.code.trim()
      : "server_error";

  const fieldMessages: string[] = [];
  if (Array.isArray(body?.data)) {
    for (const item of body.data) {
      if (!item || typeof item !== "object") continue;
      const row = item as { field?: unknown; message?: unknown };
      if (typeof row.message !== "string" || !row.message.trim()) continue;
      const msg = row.message.trim();
      if (looksLikeSecretOrToken(msg)) continue;
      const field =
        typeof row.field === "string" && row.field.trim()
          ? row.field.trim()
          : "";
      fieldMessages.push(field ? `${field}: ${msg}` : msg);
    }
  }

  let message =
    fieldMessages.length > 0
      ? fieldMessages.join("; ")
      : typeof body?.message === "string" && body.message.trim()
        ? body.message.trim()
        : "";

  if (!message || looksLikeSecretOrToken(message)) {
    message = genericAuthRequestErrorMessage;
  }

  return { code, message };
};
